var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFastForwardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 30,
    viewBox: "0 0 61 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 12.8349C26.9167 13.7972 26.9167 16.2028 25.25 17.1651L11.75 24.9593C10.0833 25.9215 8 24.7187 8 22.7942L8 7.20577C8 5.28127 10.0833 4.07846 11.75 5.04071L25.25 12.8349Z",
    fill: "black",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.523 12.8349C42.1896 13.7972 42.1896 16.2028 40.5229 17.1651L27.0229 24.9593C25.3563 25.9215 23.2729 24.7187 23.2729 22.7942L23.2729 7.20577C23.2729 5.28127 25.3563 4.07846 27.0229 5.04071L40.523 12.8349Z",
    fill: "black",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7954 12.8349C57.4621 13.7972 57.4621 16.2028 55.7954 17.1651L42.2954 24.9593C40.6287 25.9215 38.5454 24.7187 38.5454 22.7942L38.5454 7.20577C38.5454 5.28127 40.6287 4.07846 42.2954 5.04071L55.7954 12.8349Z",
    fill: "black",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastForwardIcon);
export default __webpack_public_path__ + "static/media/fast-forward-icon.8c2146ffa904efa729833a4d62c87133.svg";
export { ForwardRef as ReactComponent };